import React from 'react';
import { isMobileView } from '../../Common/utils';
import { getTypeView } from './../../CommonResp/utils'

const Content = props => {
  const { data, className, content = "" } = props;

  if (content && content.length) {
    return (
      <div className={className} dangerouslySetInnerHTML={{ __html: content }}></div>
    );
  } else if (data && data.length) {
    const view = getTemplatizedView(data, className);
    return (
      <div className={className}>
        {view}
      </div>
    );
  }
  return <></>;
};

const getTemplatizedView = (data, className='') => {
  const mobileView = isMobileView();
  let view = [<></>];
  if (className === 'seoDescTitle') {
    const { type, font, content, active, title, url } = data[0];
    if ((mobileView && active && active.length && active.indexOf('mweb') !== -1) || !mobileView && active && active.length && active.indexOf('dweb') !== -1) {
      view.push(<p key={type} className="infoTxt">
        {content?.map(item => {
          if (item?.type === 'text') {
            return item?.content
          }
          if (item?.type === 'link') {
            return <a key={type} className="infoLink" href={item?.url}>{item?.title}</a>
          }
        })}
      </p>)
    }  
  } else {
    for (let i in data) {

      const { type, font, content, active, title, url } = data[i];

      if ((mobileView && active && active.length && active.indexOf('mweb') !== -1) || !mobileView && active && active.length && active.indexOf('dweb') !== -1) {

        if (type == 'h2' || type == 'text' || type == 'link' || type == 'li') {

          view.push(getTypeView({ type, content, url, title }))
          if (type == 'text') {
            view.push(<br />);
          }
        }
        else if (type == 'text_link') {
          let textLinkView = []
          for (let j in content) {

            textLinkView.push(getTypeView({ type: content[j].type, content: content[j].content, url: content[j].url, title: content[j].title }))
          }
          view.push(<div key="templateContent">{textLinkView}</div>);
        }
      }
    }
  }
  return view;
}

export default Content;
